import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { userSecuritiesAccountsSlice } from '!core/redux';
import { authSlice } from '»components/Auth';
import { useIsAbleToProceed } from '»utils/customHooks';

import { ButtonRefreshStyled } from '../Styles';

export const ButtonRefresh = ({ disabled }) => {
  const dispatch = useDispatch();
  const { isAbleToProceed } = useIsAbleToProceed();
  const refresh = (event) => {
    isAbleToProceed(event, () => {
      dispatch(authSlice.actions.newUuid());
      dispatch(
        userSecuritiesAccountsSlice.actions.userSecuritiesAccountsRequest(),
      );
    });
  };

  return (
    <ButtonRefreshStyled
      disabled={disabled}
      onClick={(event) => refresh(event)}
      id="btnGlobalRefresh"
    >
      <FontAwesomeIcon icon={faArrowsRotate} />
    </ButtonRefreshStyled>
  );
};

ButtonRefresh.propTypes = {
  disabled: PropTypes.bool,
};
